/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaExpressOutboundInfoOrderInfoVo
 */
export interface KoreaExpressOutboundInfoOrderInfoVo {
    /**
     * 订单号
     * @type {string}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    orderCode?: string;
    /**
     * 订单类型
     * @type {number}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    orderType?: number;
    /**
     * 订单类型名称
     * @type {string}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    orderTypeName?: string;
    /**
     * 请求类型
     * @type {number}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    requestType?: number;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    requestTypeName?: string;
    /**
     * 收件人名称
     * @type {string}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    receiverName?: string;
    /**
     * 订单总箱数
     * @type {number}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    totalBoxCount?: number;
    /**
     * 订单总重量
     * @type {number}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    totalWeight?: number;
    /**
     * 出库运单号
     * @type {Array<string>}
     * @memberof KoreaExpressOutboundInfoOrderInfoVo
     */
    outboundTrackingNumbers?: Array<string>;
}

/**
 * Check if a given object implements the KoreaExpressOutboundInfoOrderInfoVo interface.
 */
export function instanceOfKoreaExpressOutboundInfoOrderInfoVo(value: object): value is KoreaExpressOutboundInfoOrderInfoVo {
    return true;
}

export function KoreaExpressOutboundInfoOrderInfoVoFromJSON(json: any): KoreaExpressOutboundInfoOrderInfoVo {
    return KoreaExpressOutboundInfoOrderInfoVoFromJSONTyped(json, false);
}

export function KoreaExpressOutboundInfoOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaExpressOutboundInfoOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'orderTypeName': json['orderTypeName'] == null ? undefined : json['orderTypeName'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'totalWeight': json['totalWeight'] == null ? undefined : json['totalWeight'],
        'outboundTrackingNumbers': json['outboundTrackingNumbers'] == null ? undefined : json['outboundTrackingNumbers'],
    };
}

export function KoreaExpressOutboundInfoOrderInfoVoToJSON(json: any): KoreaExpressOutboundInfoOrderInfoVo {
    return KoreaExpressOutboundInfoOrderInfoVoToJSONTyped(json, false);
}

export function KoreaExpressOutboundInfoOrderInfoVoToJSONTyped(value?: KoreaExpressOutboundInfoOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'orderType': value['orderType'],
        'orderTypeName': value['orderTypeName'],
        'requestType': value['requestType'],
        'requestTypeName': value['requestTypeName'],
        'receiverName': value['receiverName'],
        'totalBoxCount': value['totalBoxCount'],
        'totalWeight': value['totalWeight'],
        'outboundTrackingNumbers': value['outboundTrackingNumbers'],
    };
}

